import * as React from 'react';
import { Menu, Badge } from 'antd';
import MenuAvatar from '../../MenuAvatar';
import { NavLink } from 'react-router-dom';
import CartContext from 'Context/CartContext';

export interface Props {
  children?: React.ReactNode;
}

export interface State { }

export default class CartBadge extends React.Component<Props, State> {
  static contextType = CartContext;
  context!: React.ContextType<typeof CartContext>;
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
    return (

      <Badge count={this.context.data?.cartItems?.length} style={{ backgroundColor: "#FF6232", color: 'white' }} >
        <MenuAvatar shape="circle" icon="shopping-cart" />
            &nbsp;
        {/* {this.context.data ? this.context.data.username : ''} */}
      </Badge>

    );
  }
}
